import { render, staticRenderFns } from "./PostCreator.vue?vue&type=template&id=6eb5980c&scoped=true&"
import script from "./PostCreator.vue?vue&type=script&lang=js&"
export * from "./PostCreator.vue?vue&type=script&lang=js&"
import style0 from "./PostCreator.vue?vue&type=style&index=0&id=6eb5980c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5980c",
  null
  
)

export default component.exports